import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { ReactNode } from 'react';

import { useThemeClassName } from '../../contexts/ThemeContext';
import Button from '../buttons/Button';

import styles from '../../../styles/modals/dialog.module.scss';

interface DialogProps {
    className?: string;
    contentClassName?: string;
    closeButtonClassName?: string;
    withCloseButton?: boolean;
    onClickClose?: () => void;
    children?: ReactNode;
}

function Dialog({
    className = null,
    contentClassName = null,
    closeButtonClassName = null,
    withCloseButton = false,
    onClickClose = null,
    children = null,
}: DialogProps) {
    const themeClassName = useThemeClassName(styles);
    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            <div
                className={classNames([
                    styles.content,
                    { [contentClassName]: contentClassName !== null },
                ])}
            >
                {children}
            </div>
            {withCloseButton ? (
                <Button
                    className={classNames([
                        styles.close,
                        { [closeButtonClassName]: closeButtonClassName !== null },
                    ])}
                    onClick={onClickClose}
                >
                    <FontAwesomeIcon icon={faTimes} />
                </Button>
            ) : null}
        </div>
    );
}

export default Dialog;
